export default __webpack_public_path__ + "static/media/pic109.069a24ca.jpg";